(ns loader.events
  (:require
   [very.re-frame.core :as rf]))

(rf/reg-event-db
 :loader/show
 (fn [db]
   (assoc db :loader/status true)))

(rf/reg-event-db
 :loader/hide
 (fn [db]
   (assoc db :loader/status false)))

(rf/reg-sub
 :loader/status
 (fn [db]
   (:loader/status db)))
